import { InputIcon } from "@sellar-io/components";
import { SupplierRelationshipListParametersType } from "@sellar-io/api-v2/types";
import { useNavigate } from "react-router";
import { useDebounce } from "use-debounce";
import { SpinnerLegacy } from "../../../../components";
import { BusinessListElement } from "../../../../components/businessListElement/BusinessListElement";
import { InputContainer } from "@sellar-io/components";
import { InputText } from "@sellar-io/components";
import { InfiniteList } from "../../../../components/infiniteLoading/InfiniteList";
import {
  DialogNavigation,
  DialogContent,
} from "../../../../components/modal/Dialog";
import { ORDER_SUPPLIER } from "../../../../constants/routes";
import { useSupplierRelationshipList } from "../../../../hooks/api/v2/supplierRelationship/useSupplierRelationshipList";
import { useSearchParamState } from "../../../../hooks/useSearchParamState";

export const SelectCustomerDialogContent = ({
  onDismiss,
}: {
  onDismiss: () => void;
}) => {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useSearchParamState("search");
  const [debouncedSearchValue] = useDebounce(searchValue, 500);
  const supplierRelationshipListQuery = useSupplierRelationshipList({
    limit: 20,
    sort: [
      {
        type: "name",
        direction: "asc",
      },
    ],
    query: [
      debouncedSearchValue
        ? {
            type: "name",
            modifier: "INCLUDES",
            value: debouncedSearchValue,
          }
        : false,
      {
        type: "approved",
        modifier: "EQUALS",
        value: true,
      },
    ].filter(Boolean) as SupplierRelationshipListParametersType["query"],
  });
  return (
    <>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        title={`Select customer`}
      >
        <InputContainer>
          <InputIcon icon={"MAGNIFY"} />
          <InputText
            required={false}
            placeholder={`Search...`}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </InputContainer>
      </DialogNavigation>
      <DialogContent>
        {supplierRelationshipListQuery.isLoading &&
        supplierRelationshipListQuery.fetchStatus !== "idle" ? (
          <SpinnerLegacy />
        ) : (
          <>
            {!supplierRelationshipListQuery.data?.pages[0]?.length ? (
              <div>No customers found</div>
            ) : (
              <InfiniteList query={supplierRelationshipListQuery}>
                {supplierRelationshipListQuery.data.pages.map((page) =>
                  page.map((connection) => (
                    <BusinessListElement
                      key={connection.id}
                      business={connection.Buyer.Business}
                      onClick={() => {
                        navigate(
                          ORDER_SUPPLIER.href({ connectionId: connection.id }),
                        );
                      }}
                      text={"Place order"}
                    />
                  )),
                )}
              </InfiniteList>
            )}
          </>
        )}
      </DialogContent>
    </>
  );
};
